import AssignedVariationsContext from 'marketing-site/src/components/context/AssignedVariationsContext'
import { useContext } from 'react'

/**
 * Checks whether an optimizely experiment gets assigned the 'on' variation.
 * If the experiment needs to be evaluated on the entire site, its key needs to be added to FULL_SITE_EXPERIMENTS
 * in lib/optimizelyExperiments.ts
 * @param flagName Optimizely experiment key
 * @returns boolean
 */
export function useOptimizelyFeatureFlag(flagName: string) {
  const optimizelyVariation = useContext(AssignedVariationsContext)[flagName]
  if (!optimizelyVariation) return false

  const isFeatureActivated = optimizelyVariation.variationKey === 'on'
  return isFeatureActivated
}
